var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "Justified"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeJustified) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-tabs', {
    attrs: {
      "content-class": "mt-2",
      "justified": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Home"
    }
  }, [_c('b-card-text', [_vm._v(" Biscuit powder jelly beans. Lollipop candy canes croissant icing chocolate cake. Cake fruitcake powder pudding pastry.Danish fruitcake bonbon bear claw gummi bears apple pie. Chocolate sweet topping fruitcake cake. ")]), _c('b-card-text', [_vm._v(" Dragée jelly-o pie halvah pudding bear claw. Carrot cake pie toffee pastry candy canes. Ice cream tiramisu chocolate bar apple pie jujubes croissant toffee. Sweet roll chocolate bar pastry macaroon jelly-o. Jujubes pudding lemon drops dessert cake. Pudding cupcake chupa chups brownie. ")])], 1), _c('b-tab', {
    attrs: {
      "active": "",
      "title": "Profile"
    }
  }, [_c('b-card-text', [_vm._v(" Chocolate cake icing tiramisu liquorice toffee donut sweet roll cake. Cupcake dessert icing dragée dessert. Liquorice jujubes cake tart pie donut. Cotton candy candy canes lollipop liquorice chocolate marzipan muffin pie liquorice. ")]), _c('b-card-text', [_vm._v(" Sesame snaps chupa chups jelly-o candy croissant pastry. Lollipop pudding biscuit. Sweet roll candy canes tootsie roll halvah jujubes gummi bears toffee cheesecake. Topping macaroon marshmallow caramels. Pastry caramels pastry. ")])], 1), _c('b-tab', {
    attrs: {
      "title": "Messages"
    }
  }, [_c('b-card-text', [_vm._v(" Tootsie roll oat cake I love bear claw I love caramels caramels halvah chocolate bar. Cotton candy gummi bears pudding pie apple pie cookie. Cheesecake jujubes lemon drops danish dessert I love caramels powder. ")]), _c('b-card-text', [_vm._v(" Chocolate cake icing tiramisu liquorice toffee donut sweet roll cake. Cupcake dessert icing dragée dessert. Liquorice jujubes cake tart pie donut. Cotton candy candy canes lollipop liquorice chocolate marzipan muffin pie liquorice. ")])], 1), _c('b-tab', {
    attrs: {
      "title": "Settings"
    }
  }, [_c('b-card-text', [_vm._v(" Biscuit powder jelly beans. Lollipop candy canes croissant icing chocolate cake. Cake fruitcake powder pudding pastry.I love caramels caramels halvah chocolate bar. Cotton candy gummi bears pudding pie apple pie cookie. ")]), _c('b-card-text', [_vm._v(" Tootsie roll oat cake I love bear claw I love caramels caramels halvah chocolate bar. Cotton candy gummi bears pudding pie apple pie cookie. Cheesecake jujubes lemon drops danish dessert I love caramels powder. ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }